import request from '@/CommonDP/utils/request';
// 电子图章维护
export default {
  // 左侧树
  getElectronic(enterpriseId) {
    return request
      .get(`/electronicStamp/getElectronic?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },

  getAllElectronic(enterpriseId) {
    return request.get(`/electronicStamp/getAllElectronic?enterpriseId=${enterpriseId}`);
  },
  // 新增分类 父节点
  insertElectronic(params) {
    return request.post(`/insertElectronic`, params).then((res) => res);
  },
  // 新增分类 子节点
  addElectronic(params) {
    return request.post(`/addElectronic`, params).then((res) => res);
  },
  // 验证密码
  getCheckPassword({ fileId, password }) {
    return request.get(`/electronicStamp/checkPassword?fileId=${fileId}&password=${password}`);
  },
  // 删除 证书
  getDeleteSignFile({ sortId }) {
    return request.get(`/electronicStamp/deleteSignFile?sortId=${sortId}`);
  },
  // 绑定证书
  getBindingSign(data) {
    return request.post(`/electronicStamp/bindingSign`, data);
  },
  // 删除
  deleteChildnodes(sortId) {
    return request
      .post(`/deleteChildnodes?sortId=` + sortId)
      .then((res) => res);
  },
  // 删除
  deleteElectronic(sortId) {
    return request
      .post(`/deleteElectronic?sortId=` + sortId)
      .then((res) => res);
  },
  // 修改 分类 模板
  updateElectronic(params) {
    return request.post(`/updateElectronic`, params).then((res) => res);
  },
  uploadlist(fileID) {
    return request.get(`/uploadlist?fileID=${fileID}`);
  },
  deleteFile(sortId) {
    return request.get(`/deleteFile?sortId=${sortId}`);
  },

  queryFilesDetail(fileIds) {
    return request.post("/ca/getSignFileList", fileIds);
  },

  commintPdfSignature(json) {
    return request.post("/ca/common/signature", json);
  }
};
